/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Recentchangesdescription2Inputs */

const id_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mutasi katalog terbaru.`)
};

const ms_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mutasi katalog terkini.`)
};

const da_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste katalog-mutationer.`)
};

const de_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Katalogmutationen.`)
};

const en_us2_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest catalog mutations.`)
};

const es_es2_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas mutaciones del catálogo.`)
};

const es_mx2_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas mutaciones del catálogo.`)
};

const fil_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pinakabagong mutasyon ng catalog.`)
};

const fr_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières mutations du catalogue.`)
};

const it_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime mutazioni del catalogo.`)
};

const hu_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb katalógus módosítások.`)
};

const nl_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste catalogusmutaties.`)
};

const no_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste katalogendringer.`)
};

const pl_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze mutacje katalogu.`)
};

const pt_br2_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas mutações do catálogo.`)
};

const pt_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas mutações do catálogo.`)
};

const ro_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele mutații ale catalogului.`)
};

const fi_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusimmat katalogimutaatiot.`)
};

const sv_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste katalogförändringarna.`)
};

const vi_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các biến đổi danh mục mới nhất.`)
};

const tr_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En son katalog değişiklikleri.`)
};

const cs_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější mutace katalogu.`)
};

const bg_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последни мутации на каталога.`)
};

const ru_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние мутации каталога.`)
};

const uk_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні мутації каталогу.`)
};

const ar_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تغييرات الكتالوج.`)
};

const hi_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम कैटलॉग उत्परिवर्तन।`)
};

const th_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกลายพันธุ์ของแค็ตตาล็อกล่าสุด`)
};

const ja_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のカタログ変更。`)
};

const zh_cn2_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新的目录变更。`)
};

const zh_hant1_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新的目錄變更。`)
};

const ko_sandboxes_recentchangesdescription2 = /** @type {(inputs: Sandboxes_Recentchangesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 카탈로그 변경 사항입니다.`)
};

/**
* | output |
* | --- |
* | "Latest catalog mutations." |
*
* @param {Sandboxes_Recentchangesdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_recentchangesdescription2 = /** @type {((inputs?: Sandboxes_Recentchangesdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Recentchangesdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_recentchangesdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_recentchangesdescription2(inputs)
	if (locale === "da") return da_sandboxes_recentchangesdescription2(inputs)
	if (locale === "de") return de_sandboxes_recentchangesdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_recentchangesdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_recentchangesdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_recentchangesdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_recentchangesdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_recentchangesdescription2(inputs)
	if (locale === "it") return it_sandboxes_recentchangesdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_recentchangesdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_recentchangesdescription2(inputs)
	if (locale === "no") return no_sandboxes_recentchangesdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_recentchangesdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_recentchangesdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_recentchangesdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_recentchangesdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_recentchangesdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_recentchangesdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_recentchangesdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_recentchangesdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_recentchangesdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_recentchangesdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_recentchangesdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_recentchangesdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_recentchangesdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_recentchangesdescription2(inputs)
	if (locale === "th") return th_sandboxes_recentchangesdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_recentchangesdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_recentchangesdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_recentchangesdescription2(inputs)
	return ko_sandboxes_recentchangesdescription2(inputs)
});
export { sandboxes_recentchangesdescription2 as "sandboxes.recentChangesDescription" }